import useCapabilities, { useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";
import { isStaffMcpPlaygroundRuntime } from "@/features/mcp-playground/access";

export function canAccessM360Configuration(hasGlobalAdminRole: boolean): boolean {
  return isStaffMcpPlaygroundRuntime() && hasGlobalAdminRole;
}

export function useConfigurationAccess() {
  const { loaded } = useCapabilities();
  const isGlobalAdmin = useHasRoles([ROLE.GLOBAL_ADMIN]);
  const canView = canAccessM360Configuration(isGlobalAdmin);

  return { loaded, canView };
}
